// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"0681244ff0b1a1c9","5405":"35bdd3796f5ddcae","9335":"3a3ed6321cc4a021"}[chunkId] + ".css";
};